import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import EBPropTypes from 'js-utils/prop-types';
import PageHeader from './PageHeader';
import { ICON_TYPE_PROP_TYPE } from 'eventbrite_design_system/icon/constants';

export default class NotificationScreen extends React.PureComponent {
    static propTypes = {
        headerText: EBPropTypes.translation.isRequired,
        iconType: ICON_TYPE_PROP_TYPE.isRequired,
        subtitleText: EBPropTypes.translation,
        iconColor: PropTypes.string,
    };

    render() {
        const { headerText, iconColor, iconType, subtitleText } = this.props;

        const gridClasses = classNames(
            'eds-g-cell',
            'eds-g-cell-sm-8-12 eds-g-offset-sm-2-12',
            'eds-g-cell-sw-6-12 eds-g-offset-sw-3-12',
            'eds-g-cell-md-4-12 eds-g-offset-md-4-12',
            'eds-g-cell-10-12 eds-g-offset-1-12',
        );

        return (
            <div className="eds-g-group">
                <div className={gridClasses}>
                    <PageHeader
                        headerText={headerText}
                        iconType={iconType}
                        subtitleText={subtitleText}
                        iconColor={iconColor}
                    />
                </div>
            </div>
        );
    }
}
